import React, { useState } from 'react';

import { TextField, InputAdornment } from '@material-ui/core';
import { DateRangeOutlined } from '@material-ui/icons';
import CustomMenu, { DropdownList } from 'components/CustomMenu';
import { useDatePicker } from 'components/hooks/useDatePicker';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { convertDateToString3, convertDateToString6, convertString6ToDate } from 'constants/helper';
import { StyledIcon } from 'constants/icons';

import { StyledFilterDisplay, LastMenuItem } from '../styles';

const DateFilter = ({ selectedFilters, updateFilters, filterName, noLeftBorder = false, icon }) => {
  const [selected, setSelected] = useState([null, null]);

  const makeCurrentStateEqualToSelectedState = () => {
    setSelected(selectedFilters.length ? selectedFilters : [null, null]);
  };

  const onFromDateChange = (date) => {
    setSelected([convertDateToString6(date), selected[1]]);
  };

  const onToDateChange = (date) => {
    setSelected([selected[0], convertDateToString6(date)]);
  };

  const onFromDateClick = useDatePicker(onFromDateChange);

  const onToDateClick = useDatePicker(onToDateChange);

  const handleApplyClick = () => {
    updateFilters(selected, filterName);
    document.body.click();
  };

  const removeFilters = (e) => {
    e.stopPropagation();
    updateFilters([], filterName);
  };

  return (
    <CustomMenu
      icon={
        <StyledFilterDisplay
          width="20%"
          icon={icon}
          name={filterName}
          selectedCount={selectedFilters.filter((f) => f).length}
          noLeftBorder={noLeftBorder}
          active={selectedFilters.filter((f) => f).length > 0}
          removeFilters={removeFilters}
        />
      }
      onOpen={makeCurrentStateEqualToSelectedState}
    >
      <>
        <Container>
          <StyledTextField
            readOnly
            variant="outlined"
            value={selected[0] ? convertDateToString3(convertString6ToDate(selected[0])) : null}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <StyledIcon1 size="smallest" color="textSecondary" rightGutter={0.5}>
                    <DateRangeOutlined />
                  </StyledIcon1>
                </InputAdornment>
              ),
            }}
            placeholder="From"
            onClick={onFromDateClick}
          />
          <br />
          <StyledTextField
            readOnly
            variant="outlined"
            value={selected[1] ? convertDateToString3(convertString6ToDate(selected[1])) : null}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <StyledIcon1 size="smallest" color="textSecondary" rightGutter={0.5}>
                    <DateRangeOutlined />
                  </StyledIcon1>
                </InputAdornment>
              ),
            }}
            placeholder="To"
            onClick={onToDateClick}
          />
        </Container>
        <DropdownList>
          <LastMenuItem onClick={handleApplyClick}>
            <StyledTypography color="primary" variant="body2">
              Apply
            </StyledTypography>
          </LastMenuItem>
        </DropdownList>
      </>
    </CustomMenu>
  );
};

const Container = styled.div`
  margin: 0 0 0.75rem 0;
`;

const StyledIcon1 = styled(StyledIcon)`
  svg {
    width: 16px;
  }
`;

const StyledTextField = styled(TextField)`
  margin: 1rem 1rem 0 1rem;
  width: 145px;
  vertical-align: sub;
  input {
    padding: 10px 10px 10px 3px;
    cursor: pointer;
    font-size: 0.875rem;
    padding-left: 0;
  }
`;

export default DateFilter;
